import React from 'react';
import './List.less';
import renderTextContent, {
  TextContentType,
} from 'utils/text/renderTextContent';

interface Props {
  title: string;
  subtitle?: TextContentType;
}

export default function ListItemText({ title, subtitle }: Props) {
  return (
    <div className="base-list__item-text">
      <span className="base-list__item-title">{title}</span>
      {subtitle && (
        <p className="base-list__item-subtitle">
          {renderTextContent(subtitle)}
        </p>
      )}
    </div>
  );
}
